import { Saga } from 'redux-saga'
import { all } from 'redux-saga/effects'
import { appSaga } from '.'

export function combineAppSaga(saga?: Saga) {
  return function* () {
    yield all([saga ? saga() : undefined, appSaga()])
  }
}
